<template>
  <div>
    <v-list-item @click="openDialog" link class="px-0">
      <v-list-item-content>
        <v-list-item-title class="primary--text">
          <v-icon left color="primary">mdi-magnify</v-icon>
          Buscar cliente
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-icon color="primary">mdi-chevron-right</v-icon>
      </v-list-item-action>
    </v-list-item>

    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.mobile"
      persistent
      width="500"
    >
      <v-card>
        <v-card-title>
          Adicionar cliente
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="mt-2">
          <v-text-field
            v-model="search"
            label="Nome, código, cpf, telefone..."
            solo
            single-line
            hide-details
            autofocus
            prepend-inner-icon="mdi-magnify"
            clearable
            :loading="loading"
          ></v-text-field>
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text class="px-1">
          <v-list>
            <div v-for="item in items" :key="item.id">
              <v-list-item @click="submit(item)" link>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.nome }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </div>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { index as indexClients } from "@/services/clients";

export default {
  data() {
    return {
      dialog: false,
      search: "",
      loading: false,
      items: []
    };
  },

  methods: {
    openDialog() {
      this.dialog = true;
      this.search = "";
      this.items = [];
    },
    submit(item) {
      this.$emit("submit", item);
      this.dialog = false;
    },
    async getItems(filter) {
      const options = {
        sortBy: ["nome"],
        sortDesc: false,
        page: 1,
        itemsPerPage: 50
      };

      this.loading = true;
      try {
        const response = await indexClients(options, { filter });
        this.items = response.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  },

  watch: {
    search: _.debounce(async function(value) {
      await this.getItems(value);
    }, 500)
  }
};
</script>
